import styled from 'styled-components';

import StyledParagraph from '/shared/styled/components/StyledParagraph';

export const StyledEgridGuidance = styled.div`
  max-width: 35rem;
  margin: 0 0 2rem 14rem;
`;

export const StyledEgridGuidanceText = styled(StyledParagraph)`
  font-style: italic;
`;
